export default __webpack_public_path__ + "img/premium-rewards-card-58010fb91e0a38eee0d2ec7e11c6a022.png";